var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgValido(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d5e8fe"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 117.907,
    x2: 404.713,
    xlinkHref: "#lg1",
    y1: 46.91,
    y2: 333.716
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 251.442,
    x2: 259.282,
    y1: -5.718,
    y2: 114.127
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b5dbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48b2e3"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 32.241,
    x2: 46.622,
    y1: 36.623,
    y2: 47.579
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff637b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e63950"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 72.372,
    x2: 86.753,
    y1: 36.623,
    y2: 47.579
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdbf00"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 108.358,
    x2: 142.441,
    y1: 31.645,
    y2: 65.728
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b9dd39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b799d"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b5dbff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2428,
    stopColor: "#93cef6",
    stopOpacity: 0.243
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5763,
    stopColor: "#6abfec",
    stopOpacity: 0.576
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8403,
    stopColor: "#51b5e5",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48b2e3"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg2",
    y1: 321.18,
    y2: 420.175
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b5dbff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1734,
    stopColor: "#8fc5e9",
    stopOpacity: 0.173
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4541,
    stopColor: "#56a4c8",
    stopOpacity: 0.454
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6955,
    stopColor: "#2d8db1",
    stopOpacity: 0.696
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8853,
    stopColor: "#147ea2",
    stopOpacity: 0.885
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b799d"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 466.947,
    x2: 334.915,
    xlinkHref: "#lg3",
    y1: 370.271,
    y2: 306.497
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 111.059,
    x2: 407.341,
    y1: 135.532,
    y2: 431.814
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#76e2f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48b2e3"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 448.329,
    x2: 186.181,
    xlinkHref: "#lg2",
    y1: 477.518,
    y2: 215.37
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 204.315,
    x2: 319.471,
    xlinkHref: "#lg1",
    y1: 236.363,
    y2: 351.519
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 290.706,
    x2: 54.128,
    xlinkHref: "#lg3",
    y1: 320.109,
    y2: 206.552
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 381.208,
    x2: 300.245,
    xlinkHref: "#lg3",
    y1: 366.032,
    y2: 304.522
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 367.579,
    x2: 232.642,
    xlinkHref: "#lg3",
    y1: 423.73,
    y2: 288.793
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 207.684,
    x2: 305.737,
    y1: 263.835,
    y2: 361.888
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b9dd39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90cc1c"
  }))), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 347.465,
    x2: 311.004,
    y1: 370.706,
    y2: 334.244
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6b0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6b0"
  }))), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 246.047,
    x2: 347.603,
    y1: 236.334,
    y2: 337.89
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0b799d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07485e"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m490.588 368.006h-471.176c-10.721 0-19.412-8.691-19.412-19.412v-329.182c0-10.721 8.691-19.412 19.412-19.412h471.176c10.721 0 19.412 8.691 19.412 19.412v329.182c0 10.721-8.691 19.412-19.412 19.412z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m510 78.574h-510v-59.162c0-10.721 8.691-19.412 19.412-19.412h471.176c10.721 0 19.412 8.691 19.412 19.412z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m40.853 55.025h-10.229c-5.867 0-10.623-4.756-10.623-10.623v-10.23c0-5.867 4.756-10.623 10.623-10.623h10.229c5.867 0 10.623 4.756 10.623 10.623v10.229c0 5.868-4.756 10.624-10.623 10.624z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80.984 55.025h-10.23c-5.867 0-10.623-4.756-10.623-10.623v-10.23c0-5.867 4.756-10.623 10.623-10.623h10.229c5.867 0 10.623 4.756 10.623 10.623v10.229c.001 5.868-4.755 10.624-10.622 10.624z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.115 55.025h-10.229c-5.867 0-10.623-4.756-10.623-10.623v-10.23c0-5.867 4.756-10.623 10.623-10.623h10.229c5.867 0 10.623 4.756 10.623 10.623v10.229c0 5.868-4.756 10.624-10.623 10.624z",
    fill: "url(#SVGID_5_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m0 278.495v70.099c0 10.721 8.691 19.412 19.412 19.412h471.176c10.721 0 19.412-8.691 19.412-19.412v-70.099z",
    fill: "url(#SVGID_6_)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#b5dbff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m166.113 285.38h-104.397c-7.252 0-13.131-5.879-13.131-13.131v-126.206c0-7.252 5.879-13.131 13.131-13.131h104.397c7.252 0 13.131 5.879 13.131 13.131v126.206c.001 7.252-5.878 13.131-13.131 13.131z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m286.513 170.911h-71.598c-5.247 0-9.5-4.253-9.5-9.5v-19c0-5.247 4.253-9.5 9.5-9.5h71.598c5.247 0 9.5 4.253 9.5 9.5v19c0 5.247-4.253 9.5-9.5 9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m451.915 170.911h-125c-5.247 0-9.5-4.253-9.5-9.5v-19c0-5.247 4.253-9.5 9.5-9.5h125c5.247 0 9.5 4.253 9.5 9.5v19c0 5.247-4.253 9.5-9.5 9.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m380.317 228.146h71.598c5.247 0 9.5-4.253 9.5-9.5v-19c0-5.247-4.253-9.5-9.5-9.5h-71.598c-5.247 0-9.5 4.253-9.5 9.5v19c0 5.247 4.253 9.5 9.5 9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m214.915 228.146h125c5.247 0 9.5-4.253 9.5-9.5v-19c0-5.247-4.253-9.5-9.5-9.5h-125c-5.247 0-9.5 4.253-9.5 9.5v19c0 5.247 4.253 9.5 9.5 9.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m286.513 285.38h-71.598c-5.247 0-9.5-4.253-9.5-9.5v-19c0-5.247 4.253-9.5 9.5-9.5h71.598c5.247 0 9.5 4.253 9.5 9.5v19c0 5.247-4.253 9.5-9.5 9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m451.915 285.38h-125c-5.247 0-9.5-4.253-9.5-9.5v-19c0-5.247 4.253-9.5 9.5-9.5h125c5.247 0 9.5 4.253 9.5 9.5v19c0 5.247-4.253 9.5-9.5 9.5z"
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "m510 348.594v-81.292l-87.887-87.887c-4.451-6.108-11.656-8.078-19.794-8.078-43.294 0-85.266-14.917-118.85-42.239-16.582-13.491-40.356-13.491-56.938 0-33.584 27.322-75.556 42.239-118.85 42.239-13.519 0-22.477 8.958-22.477 22.477v65.605c0 37.764 7.638 74.623 21.952 108.587h383.432c10.721 0 19.412-8.691 19.412-19.412z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m402.319 169.335c-43.294 0-85.266-14.917-118.85-42.239-16.582-13.49-40.356-13.491-56.938 0-33.584 27.322-75.556 42.239-118.85 42.239-13.519 0-24.479 10.959-24.479 24.479v65.605c0 84.162 37.898 163.85 103.183 216.964l20.15 16.393c28.229 22.966 68.701 22.966 96.93 0l20.15-16.393c65.285-53.114 103.183-132.805 103.183-216.967 0-25.188 0-48.857 0-65.608-.001-13.52-10.96-24.473-24.479-24.473z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 488.402c-4.72 0-9.335-1.64-12.997-4.619l-38.539-31.354c-28.149-22.902-51.266-52.329-66.851-85.1s-23.823-69.274-23.823-105.563v-52.063c0-6.298 5.149-11.654 11.439-11.987 42.891-2.268 84.356-18.173 117.774-45.361 3.662-2.979 8.277-4.619 12.997-4.619s9.335 1.64 12.996 4.619c33.419 27.189 74.885 43.094 117.777 45.361 6.288.333 11.437 5.687 11.437 11.985v52.061c0 36.289-8.238 72.792-23.823 105.565-15.585 32.772-38.702 62.2-66.851 85.102l-38.539 31.354c-3.662 2.979-8.277 4.619-12.997 4.619z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 474.028c-4.321 0-8.548-1.502-11.9-4.229l-35.287-28.708c-25.774-20.969-46.94-47.913-61.21-77.919s-21.813-63.429-21.813-96.655v-47.669c0-5.767 4.715-10.67 10.474-10.975 39.272-2.077 77.238-16.639 107.836-41.533 3.353-2.728 7.579-4.23 11.9-4.23 4.322 0 8.548 1.502 11.9 4.229 30.599 24.894 68.566 39.457 107.838 41.534 5.758.304 10.472 5.207 10.472 10.973v47.668c0 33.227-7.543 66.65-21.813 96.656-14.27 30.007-35.436 56.951-61.21 77.92l-35.287 28.709c-3.352 2.727-7.578 4.229-11.9 4.229z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m426.797 193.808c0-13.519-10.96-24.473-24.479-24.473-43.294 0-85.266-14.917-118.85-42.239-8.291-6.745-18.38-10.118-28.469-10.118v393.022c17.175 0 34.351-5.742 48.465-17.225l20.15-16.393c65.285-53.114 103.183-132.805 103.183-216.967 0-25.187 0-48.857 0-65.607z",
    fill: "url(#SVGID_11_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m383.253 231.347c-7.699-7.698-20.182-6.121-27.881 1.578l-96.058 96.058c-.936.936-3.583 2.711-4.314 2.711s-1.799-.197-2.736-1.134l-36.821-36.821c-7.7-7.699-19.393-7.699-27.092 0s-8.488 18.604-.789 26.303l146.972 146.972c54.815-49.484 87.838-118.676 91.847-192.392z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m323.615 476.382c46.598-37.911 79.238-89.363 94.109-146.315l-88.842-88.842c-18.542-19.584-44.784-30.225-73.881-30.225-55.439 0-100.152 44.713-100.152 100.152 0 29.097 10.641 55.338 30.225 73.88l106.777 106.777c3.262 3.262 8.464 3.529 12.043.617z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 311.151,
    fill: "url(#SVGID_14_)",
    r: 101.729
  }), /*#__PURE__*/React.createElement("path", {
    d: "m337.149 251.148-77.835 77.835c-.936.936-3.583 2.711-4.314 2.711s-1.799-.197-2.736-1.134l-36.821-36.821c-7.7-7.699-19.393-7.699-27.092 0s-8.488 18.604-.789 26.303l90.264 90.264c45.192-10.361 78.903-50.821 78.903-99.156 0-22.44-7.272-43.18-19.58-60.002z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 369.546c-11.566 0-22.439-4.504-30.617-12.683l-36.821-36.82c-7.699-7.699-7.699-20.182 0-27.881s20.182-7.699 27.881 0l36.821 36.821c.937.937 2.005 1.134 2.736 1.134s1.799-.197 2.735-1.133l97.637-97.636c7.699-7.699 20.182-7.698 27.881 0 7.699 7.699 7.699 20.182 0 27.881l-97.636 97.636c-8.178 8.177-19.051 12.681-30.617 12.681z",
    fill: "url(#SVGID_16_)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValido);
export default __webpack_public_path__ + "static/media/valido.535eff785a8338efcc0c69c2d7c1a49b.svg";
export { ForwardRef as ReactComponent };